// src/features/dataSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

// Async thunk to fetch data from API
export const createPassword = createAsyncThunk(
  "create/createPassword",
  async ({ id, values, type }) => {
    try {
      const normalizedType = type.startsWith("activate-")
        ? type.replace("activate-", "")
        : type;
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/user/activate/${normalizedType}/${id}`,
        values,
      );
      return response.data;
    } catch (error) {
      toast.error(error.response?.data?.message);
    }
  },
);

const createPasswordSlice = createSlice({
  name: "create",
  initialState: {
    createpassword: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.createpassword = action.payload;
      })
      .addCase(createPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default createPasswordSlice.reducer;
